import { render, staticRenderFns } from "./Infra.vue?vue&type=template&id=4b4dd2ca"
import script from "./Infra.vue?vue&type=script&lang=js"
export * from "./Infra.vue?vue&type=script&lang=js"
import style0 from "./Infra.vue?vue&type=style&index=0&id=4b4dd2ca&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports